// src/Header.jsx

const focusAreas = [
  {
    icon: "🛠️",
    title: "Cultura maker",
    desc: "Projetos mão na massa com materiais simples e tecnologia.",
  },
  {
    icon: "🚀",
    title: "Hackathons educacionais",
    desc: "Desafios criativos que conectam teoria e prática.",
  },
  {
    icon: "📚",
    title: "ABP & projetos integradores",
    desc: "Aprendizagem Baseada em Projetos em diferentes etapas de ensino.",
  },
  {
    icon: "🎓",
    title: "Formação de professores",
    desc: "Metodologias ativas, tecnologias e inovação na prática.",
  },
  {
    icon: "💡",
    title: "Transformação digital",
    desc: "Uso intencional de tecnologias na escola e na rede.",
  },
  {
    icon: "📊",
    title: "Sequências em Ciência de Dados",
    desc: "Propostas didáticas ligadas a dados e cultura digital.",
  },
];

function Header() {
  return (
    <header className="header-hero">
      <div className="header-hero-inner">
        <div className="header-hero-content">
          <p className="header-kicker">Karen Carvalho | Experiências de Aprendizagem</p>

          <h1 className="header-title">
            Educação, inovação e tecnologia para experiências de aprendizagem
            mais vivas.
          </h1>

          <p className="header-subtitle">
            Apoio escolas, redes e educadores a implementarem cultura maker,
            hackathons educacionais, ABP e transformação digital de forma
            possível, em diálogo com a realidade de cada contexto.
          </p>
          
        </div>

   
      </div>
    </header>
  );
}

export default Header;
